export interface OpportunityDocumentTypeReq {
  page?: number;
  fetch?: number;
  offsetId?: number;
}
